import { Dispatch, SetStateAction } from "react";
import {
  FourDPQuizResultsType,
  TrainingProgressionUpdateType,
  UserType,
} from "@WahooFitness/cloud-client-types";
import useFourDPQuiz from "./useFourDPQuiz";
import Quiz from "../Quiz";

interface Props {
  user: UserType;
  setResults: Dispatch<SetStateAction<FourDPQuizResultsType | undefined>>;
  setError: Dispatch<SetStateAction<string | undefined>>;
  setPage: Dispatch<SetStateAction<number>>;
  skipEducation: boolean;
  setInitialTrainingProgression: Dispatch<
    SetStateAction<TrainingProgressionUpdateType | undefined>
  >;
  onFirstStepBack?: () => void;
}

function FourDPQuiz({
  user,
  setResults,
  setError,
  setPage,
  skipEducation,
  setInitialTrainingProgression,
  onFirstStepBack,
}: Props) {
  const quizProps = useFourDPQuiz(
    user,
    setResults,
    setPage,
    setError,
    skipEducation,
    setInitialTrainingProgression,
    onFirstStepBack
  );
  return <Quiz {...quizProps} />;
}

export default FourDPQuiz;
